import GuideTopicPage from "./GuideTopicPage"

export default GuideTopicPage